<template>
  <div class="container-fluid">
    <div style="text-align: center" class="row justify-content-md-center">
      <div class="col-md-6">
        <h2>Top Papers</h2>
      </div>
      <div class="col-md-6">
        <button class="btn btn-primary" @click="navigateToUpload">Upload paper</button>
      </div>
    </div>
    <Feed />
  </div>
</template>

<script>
// @ is an alias to /src
import Feed from '@/components/Feed.vue';

export default {
  name: 'home',
  components: {
    Feed,
  },
  methods: {
    navigateToUpload() {
      this.$router.push({ path: '/upload' })
    }
  }
};
</script>
